export const getListProductOptionsMixin = {
  data() {
    return {
      listProductCategory: [],
      listProductGroup: [],
    }
  },
  methods: {
    productNameWithMaster({ name, master }) {
      return name + " - " + master;
    },
    getListProductGroup() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/product-group")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listProductGroup = response.data;
            }
          }
        })
        .finally(() => {
          this.listProductGroupLoading = false;
        });
    },
    getListProductCategory() {
      this.$http
        .get(process.env.VUE_APP_API_URL + "/product-category")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listProductCategory = response.data;
            }
          }
        })
        .finally(() => {
          this.listProductCategoryLoading = false;
        });
    },
    getListProduct(asset, selectedProduct) {
      this.listProductLoading = true;

      if (!selectedProduct) {
        if (this.formData.product) {
          this.formData.product = null;
        } else if (this.formData.accounts) {
          this.formData.accounts.product = null;
        }
      }

      this.$http
        .get(process.env.VUE_APP_API_URL + "/product?asset_id=" + asset.id)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listProduct = response.data;

              if (selectedProduct) {
                this.formData.product = selectedProduct;
                this.formReady = true;
              } else {
                if (response.data.length == 1) {
                  this.formData.product = response.data[0]
                  this.formData.member_account.product = response.data[0]
                }
              }
            }
          }
        })
        .finally(() => {
          this.listProductLoading = false;
        });
    },
  }
};